import React, { useState } from 'react'
import getActivityChartOptions from '../../../utils/charts/baseActivityChart'
import ChartModule from './ChartModule'
import TabPanel from '../../layout/TabPanel'
import ActivityTable from '../Tables/ActivityTable'
import { Box, Card, CardContent, Tab, Tabs, Typography } from '@mui/material'
import { a11yProps } from '../../../constants/constants'
import { type IChartOptionsParams } from '../../../interfaces/chart.interface'

export default function ActivityChart (props: IChartOptionsParams): JSX.Element {
  const [selectedActivityTab, setSelectedActivityTab] = useState(0)
  const pagePrefix = 'activity-metric__tab'

  const renderChartPanel = (): JSX.Element => {
    return (
      <Card className='chart-card' id='activity-card'>
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'end', m: 0 }}>
            <Typography variant='h6' color='#7f7f7f'> Activity </Typography>
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={selectedActivityTab}
              onChange={(_e, val) => { setSelectedActivityTab(val) }}
              aria-label='Profile tabs'
            >
              <Tab data-testid='activity__charts-tab' label='Graph' {...a11yProps(pagePrefix, 0)} />
              <Tab data-testid='activity__table-tab' label='Table' {...a11yProps(pagePrefix, 1)} />
            </Tabs>
          </Box>
          <TabPanel value={selectedActivityTab} index={0} noPadding>
            <ChartModule
              hideHeader
              hideBorder
              showChartActions
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
              metricType='activity'
              getChartOptions={getActivityChartOptions}
              showMemberAlerts={props.showMemberAlerts}
              handleAlertClick={props.handleAlertClick} // eslint-disable-line react/jsx-handler-names
            />
          </TabPanel>
          <TabPanel value={selectedActivityTab} index={1} noPadding>
            <ActivityTable
              hideHeader
              hideBorder
              dashboardViewStore={props.dashboardViewStore}
              memberObj={props.memberObj}
            />
          </TabPanel>
        </CardContent>
      </Card>
    )
  }

  return renderChartPanel()
}
